import React from "react";

function BS4_Buttons() {
  return (
    <div>
      <h1>BS4_Buttons Component</h1>
      <p>This is the BS4_Buttons tutorial page content.</p>
    </div>
  );
}

export default BS4_Buttons;
